<template>
    <UnifiedLayout v-slot="{ toggleSidebar }" :title="title">
        <div class="flex flex-1 flex-col md:pl-64 sticky top-0 z-20">
            <div class=" z-10 flex h-16 flex-shrink-0 bg-white shadow">
                <button
                    v-if="!searchAreaActive"
                    class="border-r border-gray-200 px-4 text-gray-500 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-gray-500 md:hidden"
                    type="button"
                    @click="toggleSidebar(true)">
                    <span class="sr-only">Open sidebar</span>
                    <Bars3BottomLeftIcon aria-hidden="true" class="h-6 w-6"/>
                </button>
                <div class="flex flex-1 justify-between px-4">
                    <div class="flex flex-1">
                        <TopbarSearch :type="searchType" @update-search-area-active="updateSearchAreaActive"/>
                    </div>
                </div>
            </div>
        </div>
        <div class="flex flex-1 flex-col md:pl-64">
            <main class="flex-1">
                <ContentContainer v-if="!noContainer" class="py-6">
                    <slot/>
                </ContentContainer>


                <div v-if="noContainer">
                    <slot/>
                </div>
            </main>
            <FooterLinks/>
        </div>
    </UnifiedLayout>
</template>
<script>
import UnifiedLayout from '@/Layouts/Legacy/UnifiedLayout.vue';
import ContentContainer from '@/Components/Legacy/ContentContainer.vue';
import {Bars3BottomLeftIcon, MagnifyingGlassIcon} from '@heroicons/vue/24/outline/esm/index.js';
import TopbarSearch from '@/Layouts/Legacy/Partials/TopbarSearch.vue';
import FooterLinks from '@/Components/Legacy/Marketing/FooterLinks.vue';

export default {
    components: {
        FooterLinks,
        TopbarSearch,
        ContentContainer,
        UnifiedLayout,
        Bars3BottomLeftIcon,
        MagnifyingGlassIcon
    },
    props: {
        title: {
            type: String,
            required: true,
        },

        searchType: {
            type: String,
            default: () => 'investor',
        },
        noContainer: {
            type: Boolean,
            required: false,
            default: () => false,
        }
    },

    data() {
        return {
            searchAreaActive: false,
        };
    },

    methods: {
        updateSearchAreaActive(value) {
            this.searchAreaActive = value;
        }
    }
};
</script>
